export default __webpack_public_path__ + "5d788c18989858fd6a0dba9d9fa10984.svg";